import React from 'react';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from './ui/select';
import { TERRITOIRES, findTerritoire } from '../constants/countries';
import { Flag } from './Flag';

/**
 * TerritorySelect : selecteur de territoire (drapeau + nom + indicatif) uniforme.
 * Props :
 *  - value : territoire courant (string)
 *  - onChange : (value) => void  (retourne '' si "Aucun")
 *  - placeholder : texte du placeholder
 *  - testId : prefix pour data-testid
 *  - allowNone : afficher "— Aucun —" en tete
 *  - className : classes CSS optionnelles pour le trigger
 */
export function TerritorySelect({
  value,
  onChange,
  placeholder = 'Sélectionner un territoire',
  testId = 'territoire',
  allowNone = true,
  className = '',
}) {
  const current = value ? findTerritoire(value) : null;
  return (
    <Select value={value || ''} onValueChange={(v) => onChange(v === '__none__' ? '' : v)}>
      <SelectTrigger className={className} data-testid={testId}>
        <SelectValue placeholder={placeholder}>
          {current ? (
            <span className="flex items-center gap-2">
              <Flag iso={current.iso} size={16} />
              <span>{current.label}</span>
            </span>
          ) : null}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-[280px]">
        {allowNone && (
          <SelectItem value="__none__" data-testid={`${testId}-opt-none`}>— Aucun —</SelectItem>
        )}
        {TERRITOIRES.map(t => (
          <SelectItem key={t.value} value={t.value} data-testid={`${testId}-opt-${t.value}`}>
            <span className="flex items-center gap-2">
              <Flag iso={t.iso} size={16} />
              <span>{t.label}</span>
              {t.dial ? <span className="text-xs text-[#5E6D66]">{t.dial}</span> : null}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default TerritorySelect;
